"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "card-resources-counter" };
const _hoisted_2 = { class: "card-resources-counter-number" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("span", _hoisted_2, (0, vue_1.toDisplayString)(_ctx.amount), 1),
        (0, vue_1.createElementVNode)("span", {
            class: (0, vue_1.normalizeClass)(["card-resource", _ctx.cssClass])
        }, null, 2)
    ]));
}
